import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import DienteSVG from '../paciente/DienteSVG';

const ModalOdontogramaLaboratorio = ({ show, onHide, initialData, onSave, readOnly = false }) => {
    // Estado del Odontograma actual
    const [dientesState, setDientesState] = useState({});
    const [herramienta, setHerramienta] = useState({ id: 'seleccion', label: 'Seleccionar (Ver)', tipo: 'none' });

    // Herramientas / Convenciones
    const herramientas = [
        // Fila 1
        { id: 'endodoncia_realizada', label: 'Endodoncia Realizada', color: 'blue', tipo: 'atributo', key: 'endodoncia', value: 'realizada', symbol: '△' },
        { id: 'provisional_presente', label: 'Provisional Presente', color: 'blue', tipo: 'atributo', key: 'provisional', value: 'presente', symbol: 'P' },
        { id: 'corona_desadaptada', label: 'Corona Desadaptada', color: 'red', tipo: 'atributo', key: 'corona', value: 'desadaptada', symbol: '○' },
        { id: 'caries', label: 'Caries', color: '#dc3545', tipo: 'sector' },

        // Fila 2
        { id: 'endodoncia_indicada', label: 'Endodoncia Indicada', color: 'red', tipo: 'atributo', key: 'endodoncia', value: 'indicada', symbol: '△' },
        { id: 'provisional_indicado', label: 'Provisional Indicado', color: 'red', tipo: 'atributo', key: 'provisional', value: 'indicado', symbol: 'P' },
        { id: 'corona_presente', label: 'Corona Presente', color: 'blue', tipo: 'atributo', key: 'corona', value: 'presente', symbol: '○' },
        { id: 'obturacion', label: 'Obturación', color: '#007bff', tipo: 'sector' },

        // Fila 3
        { id: 'sellante_presente', label: 'Sellante Presente', color: 'blue', tipo: 'atributo', key: 'sellante', value: 'presente', symbol: 'S' },
        { id: 'implante_integrado', label: 'Implante Integrado', color: 'blue', tipo: 'atributo', key: 'implante', value: 'integrado', symbol: '¦' },
        { id: 'nucleo_indicado', label: 'Núcleo Indicado', color: 'red', tipo: 'atributo', key: 'nucleo', value: 'indicado', symbol: '▲' },
        { id: 'resina_indicada', label: 'Resina Indicada', color: 'red', tipo: 'sector' },

        // Fila 4
        { id: 'sellante_indicado', label: 'Sellante Indicado', color: 'red', tipo: 'atributo', key: 'sellante', value: 'indicado', symbol: 'S' },
        { id: 'implante_no_integrado', label: 'Implante No Integrado', color: 'red', tipo: 'atributo', key: 'implante', value: 'no_integrado', symbol: '¦' },
        { id: 'nucleo_presente', label: 'Núcleo', color: 'green', tipo: 'atributo', key: 'nucleo', value: 'presente', symbol: '▲' },
        { id: 'resina_presente', label: 'Resina Presente', color: 'blue', tipo: 'sector' },

        // Fila 5
        { id: 'ausente', label: 'Diente Ausente', color: 'black', tipo: 'condicion', value: 'ausente', symbol: '❙' },
        { id: 'pontico', label: 'Póntico', color: 'green', tipo: 'condicion', value: 'pontico', symbol: '⫘' },
        { id: 'exodoncia_indicada', label: 'Exodoncia Indicada', color: 'red', tipo: 'condicion', value: 'exodoncia_indicada', symbol: '❌' },
        { id: 'limpiar_sector', label: 'Borrar Sector', color: '#ffc107', tipo: 'sector' },

        // Fila 6
        { id: 'extraccion', label: 'Diente Extraído', color: 'red', tipo: 'condicion', value: 'extraccion', symbol: '❙' },
        { id: 'pilar_izquierdo', label: 'Pilar Izquierdo', color: 'green', tipo: 'condicion', value: 'pilar_izquierdo', symbol: '⫗' },
        { id: 'brackets', label: 'Brackets', color: 'red', tipo: 'atributo', key: 'brackets', value: 'presente', symbol: '▣' },
        { id: 'limpiar_diente', label: 'Limpiar Diente', color: '#f39c12', tipo: 'accion_diente' },

        // Fila 7
        { id: 'carilla_presente', label: 'Carilla Presente', color: 'blue', tipo: 'sector' },
        { id: 'pilar_derecho', label: 'Pilar Derecho', color: 'green', tipo: 'condicion', value: 'pilar_derecho', symbol: '⫙' },
        { id: 'rotacion_migracion', label: 'Rotaciones y Migraciones', color: 'blue', tipo: 'atributo', key: 'rotacion', value: 'presente', symbol: '⇄' },
        { id: 'diente_sano', label: 'Diente Sano (General)', color: '#232d8dff', tipo: 'condicion', value: 'sano', symbol: '✓' },

        // Fila 8
        { id: 'carilla_desadaptada', label: 'Carilla Desadaptada', color: 'red', tipo: 'sector' },
        { id: 'paciente_edentulo', label: 'Paciente Edéntulo', color: 'purple', tipo: 'macro', symbol: '🦷' },
        { id: 'vacio_1', label: '', color: 'transparent', tipo: 'none' },
        { id: 'vacio_2', label: '', color: 'transparent', tipo: 'none' }
    ];

    // Cargar datos iniciales al mostrar
    useEffect(() => {
        if (show) {
            if (initialData && Object.keys(initialData).length > 0) {
                // Si initialData viene como string JSON, parsearlo
                let data = initialData;
                if (typeof initialData === 'string') {
                    try {
                        data = JSON.parse(initialData);
                    } catch (e) {
                        console.error("Error parseando datos iniciales del odontograma", e);
                        data = {};
                    }
                }
                setDientesState(data);
            } else {
                setDientesState({});
            }
        }
    }, [show, initialData]);

    const handleGuardar = () => {
        if (onSave) {
            onSave(dientesState);
        }
        onHide();
    };

    // --- Lógica del Odontograma (Click Handler) - VERSIÓN "ROBUSTA" CON REGLAS CLÍNICAS ---
    const handleDienteClick = (numero, zona) => {
        if (readOnly) return; // Bloquear clicks en modo lectura

        setDientesState(prevState => {
            const newState = { ...prevState };

            // Inicializar si no existe, o CLONAR si existe para no mutar el estado anterior (Immutability Fix)
            if (!newState[numero]) {
                newState[numero] = { sectores: {}, atributos: {} };
            } else {
                newState[numero] = {
                    ...newState[numero],
                    sectores: { ...(newState[numero].sectores || {}) },
                    atributos: { ...(newState[numero].atributos || {}) }
                };
            }
            const diente = newState[numero];

            // 1. HERRAMIENTA LIMPIAR TODO EL DIENTE
            if (herramienta.id === 'limpiar_diente') {
                delete newState[numero];
                return newState;
            }

            // 2. REGLAS CLÍNICAS: ESTADOS CRÍTICOS (Ausente, Extraído, Exodoncia, Sano)
            // Sano también limpia todo para resetear el diente
            const esEstadoCritico = ['ausente', 'extraccion', 'exodoncia_indicada', 'sano'].includes(herramienta.value);

            if (esEstadoCritico) {
                const yaEstaPuesto = diente.condicion === herramienta.value;
                if (yaEstaPuesto) {
                    delete newState[numero];
                } else {
                    // Al marcar como crítico, se pierde todo lo demás (sectores y atributos)
                    newState[numero] = { sectores: {}, atributos: {}, condicion: herramienta.value };
                }
                return newState;
            }

            // Si el diente está marcado como ausente o extraído, bloqueamos cualquier otra acción
            // Excepto si se quiere cambiar la condición o limpiar el diente (ya manejado arriba)
            if (['ausente', 'extraccion'].includes(diente.condicion) && herramienta.tipo !== 'condicion') {
                return prevState;
            }

            const currentDiente = newState[numero];

            // 3. REGLAS PARA SECTORES (Caries, Resinas, Carillas)
            if (herramienta.tipo === 'sector') {
                // REGLA: No se permiten sectores sobre un Implante
                if (currentDiente.atributos?.implante) {
                    return prevState;
                }

                // REGLA: No se permiten carillas si hay una Corona (la corona cubre todo)
                if (herramienta.id.includes('carilla') && currentDiente.atributos?.corona) {
                    return prevState; // No puede haber carilla si hay corona
                }

                if (herramienta.id === 'limpiar_sector') {
                    const newSectores = { ...currentDiente.sectores };
                    delete newSectores[zona];
                    currentDiente.sectores = newSectores;
                } else {
                    // Toggle para el sector específico
                    if (currentDiente.sectores[zona] === herramienta.id) {
                        const newSectores = { ...currentDiente.sectores };
                        delete newSectores[zona];
                        currentDiente.sectores = newSectores;
                    } else {
                        currentDiente.sectores = {
                            ...currentDiente.sectores,
                            [zona]: herramienta.id
                        };
                    }
                }
            }

            // 4. REGLAS PARA ATRIBUTOS Y CONDICIONES (Coronas, Implantes, Endodoncias, etc.)
            else if (herramienta.tipo === 'atributo' || herramienta.tipo === 'condicion') {
                const key = herramienta.key;
                const value = herramienta.value;

                // Verificamos si ya está puesto para Toggle
                const yaEstaPuesto = (herramienta.tipo === 'atributo' && currentDiente.atributos?.[key] === value) ||
                    (herramienta.tipo === 'condicion' && currentDiente.condicion === value);

                if (yaEstaPuesto) {
                    // Remover atributo o condición
                    if (herramienta.tipo === 'atributo') {
                        const newAtributos = { ...currentDiente.atributos };
                        delete newAtributos[key];
                        currentDiente.atributos = newAtributos;
                    } else {
                        delete currentDiente.condicion;
                    }
                } else {
                    // APLICAR NUEVO TRATAMIENTO CON REGLAS DE COMPATIBILIDAD

                    // A. IMPLANTE: Limpia endodoncia, sellantes y todos los sectores (caries/resinas)
                    if (herramienta.id.includes('implante')) {
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                        delete currentDiente.atributos.endodoncia;
                        delete currentDiente.atributos.sellante;
                        delete currentDiente.atributos.nucleo;
                        currentDiente.sectores = {};
                    }

                    // B. ENDODONCIA: Incompatible con Implante
                    else if (herramienta.id.includes('endodoncia')) {
                        if (currentDiente.atributos?.implante) return prevState;
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    }

                    // C. CORONA / PROVISIONAL: Limpia sellantes y carillas, y son excluyentes entre sí
                    else if (herramienta.id.includes('corona') || herramienta.id.includes('provisional')) {
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };

                        // Exclusividad mutua entre corona y provisional
                        if (key === 'corona') delete currentDiente.atributos.provisional;
                        if (key === 'provisional') delete currentDiente.atributos.corona;

                        // Eliminar sellante si existe
                        delete currentDiente.atributos.sellante;
                        // Eliminar sectores de carilla si existen
                        const newSectores = { ...currentDiente.sectores };
                        Object.keys(newSectores).forEach(z => {
                            if (newSectores[z]?.includes('carilla')) delete newSectores[z];
                        });
                        currentDiente.sectores = newSectores;
                    }

                    // D. SELLANTE: Incompatible con Implante y Corona
                    else if (herramienta.id.includes('sellante')) {
                        if (currentDiente.atributos?.implante || currentDiente.atributos?.corona) return prevState;
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    }

                    // E. NUCLEO: Incompatible con Implante (normalmente)
                    else if (herramienta.id.includes('nucleo')) {
                        if (currentDiente.atributos?.implante) return prevState;
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    }

                    // RESTO DE ATRIBUTOS / CONDICIONES
                    else if (herramienta.tipo === 'atributo') {
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    } else {
                        currentDiente.condicion = value;
                    }
                }
            }
            return newState;
        });
    };

    // --- Renderizado de Botones ---
    const renderButton = (tool) => {
        const isSelected = herramienta.id === tool.id;

        let iconStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            marginRight: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0
        };

        let innerContent = null;

        if (tool.id.includes('resina')) {
            const color = tool.id.includes('presente') ? 'blue' : 'red';
            iconStyle.backgroundImage = `repeating-linear-gradient(45deg, white, white 2px, ${color} 2px, ${color} 4px)`;
        } else if (tool.id.includes('carilla')) {
            const color = tool.id.includes('presente') ? 'blue' : 'red';
            iconStyle.backgroundImage = `linear-gradient(90deg, ${color} 1px, transparent 1px)`;
            iconStyle.backgroundSize = '4px 100%';
        } else if (tool.tipo === 'sector' && !tool.symbol) {
            iconStyle.backgroundColor = tool.color;
        } else {
            iconStyle.backgroundColor = 'transparent';
            iconStyle.border = 'none';
            iconStyle.color = tool.color;
            innerContent = tool.symbol;

            if (tool.id === 'limpiar_diente') innerContent = '✨';
            if (tool.id === 'limpiar_sector') innerContent = '🧹';

            if (tool.id === 'exodoncia_indicada') {
                innerContent = '❌';
                iconStyle.color = 'red';
            }
        }

        return (
            <div className="col-md-3 mb-2" key={tool.id}>
                <button
                    className={`btn btn-sm w-100 ${isSelected ? 'btn-primary' : 'btn-outline-secondary'}`}
                    style={{
                        visibility: tool.tipo === 'none' ? 'hidden' : 'visible',
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        padding: '6px 10px',
                        fontSize: '13px',
                        opacity: readOnly ? 0.6 : 1, // Opacidad si es readonly
                        cursor: readOnly ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                        if (readOnly) return;
                        if (tool.tipo === 'none') return;
                        if (tool.id === 'paciente_edentulo') {
                            if (window.confirm("¿Está seguro de marcar al paciente como edéntulo? Esto reemplazará todo el contenido de los dientes posteriores y anteriores.")) {
                                setDientesState(prevState => {
                                    const newState = { ...prevState };
                                    const dientesEdentulo = [
                                        18, 17, 16, 15, 14, 13, 12, 11,
                                        21, 22, 23, 24, 25, 26, 27, 28,
                                        48, 47, 46, 45, 44, 43, 42, 41,
                                        31, 32, 33, 34, 35, 36, 37, 38
                                    ];

                                    dientesEdentulo.forEach(num => {
                                        newState[num] = { sectores: {}, atributos: {}, condicion: 'extraccion' };
                                    });
                                    return newState;
                                });
                            }
                        } else {
                            setHerramienta(tool);
                        }
                    }}
                    disabled={readOnly}
                >
                    <div style={iconStyle}>{innerContent}</div>
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{tool.label}</span>
                </button>
            </div >
        );
    };

    const renderOdontogramaContent = () => {
        const quadrants = [
            [18, 17, 16, 15, 14, 13, 12, 11],
            [21, 22, 23, 24, 25, 26, 27, 28],
            [55, 54, 53, 52, 51],
            [61, 62, 63, 64, 65],
            [85, 84, 83, 82, 81],
            [71, 72, 73, 74, 75],
            [48, 47, 46, 45, 44, 43, 42, 41],
            [31, 32, 33, 34, 35, 36, 37, 38]
        ];

        const renderRow = (dientes) => (
            <div className="d-flex justify-content-center">
                {dientes.map(num => (
                    <DienteSVG
                        key={num}
                        numero={num}
                        estado={dientesState[num]}
                        onSectorClick={handleDienteClick}
                        style={{ cursor: readOnly ? 'default' : 'pointer' }}
                    />
                ))}
            </div>
        );

        return (
            <div className="odontograma-container" style={{ overflowX: 'auto', padding: '10px' }}>
                <div className="d-flex justify-content-center mb-2 gap-4">
                    {renderRow(quadrants[0])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[1])}
                </div>
                <div className="d-flex justify-content-center mb-4 gap-4">
                    {renderRow(quadrants[2])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[3])}
                </div>
                <div className="d-flex justify-content-center mb-2 gap-4">
                    {renderRow(quadrants[4])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[5])}
                </div>
                <div className="d-flex justify-content-center gap-4">
                    {renderRow(quadrants[6])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[7])}
                </div>
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{readOnly ? 'Odontograma (Solo Lectura)' : 'Odontograma de Laboratorio'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid">
                    {!readOnly && (
                        <div className="alert alert-info">
                            <i className="fas fa-info-circle mr-2"></i>
                            Este odontograma se guardará adjunto a la orden de laboratorio.
                        </div>
                    )}

                    <div className="card mb-3">
                        <div className="card-body bg-light text-center">
                            {renderOdontogramaContent()}
                        </div>
                    </div>

                    <div className="card mb-3">
                        <div className="card-header py-1">Herramientas</div>
                        <div className="card-body py-2">
                            <div className="row">
                                {herramientas.map(renderButton)}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>{readOnly ? 'Cerrar' : 'Cancelar'}</Button>
                {!readOnly && (
                    <Button variant="success" onClick={handleGuardar}>
                        <i className="fas fa-check mr-2"></i> Confirmar Odontograma
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalOdontogramaLaboratorio;
